export default "__VITE_ASSET__MWPj4yYt__"